<div class="modal p-15">
  <div class="modal-header header pb-30">
    <span class="header-title" mat-dialog-title>Configurações</span>
  </div>
  <form [formGroup]="form">
    <div class="d-flex vw-100 column-gap-20 ptb-10">
      <app-c-input
        class="form-input flex-1"
        label="Subsidiária"
        formControlName="Subsidiary"
      >
      </app-c-input>
      <app-c-input
        class="form-input flex-1"
        label="Loja"
        formControlName="Store"
      >
      </app-c-input>
    </div>
    <div class="d-flex vw-100 column-gap-20 ptb-10">
      <app-c-select
        class="flex-1"
        width="100%"
        height="33px"
        label="Banco"
        alignItem="flex-start"
        formControlName="Bank"
        borderRadius="5px"
        borderColor="#c4c4c4"
        [isStoreConfig]="true"
        [data]="parameters?.Bank || []"
      ></app-c-select>
      <app-c-select
        class="flex-1"
        width="100%"
        height="33px"
        label="Produto"
        alignItem="flex-start"
        formControlName="Product"
        borderRadius="5px"
        borderColor="#c4c4c4"
        [isStoreConfig]="true"
        [data]="parameters?.Product || []"
      ></app-c-select>
    </div>
    <div class="d-flex vw-100 column-gap-20 ptb-10">
      <app-c-input
        class="form-input flex-1"
        label="Comissão %"
        formControlName="Commission"
        inputType="number"
      >
      </app-c-input>
      <app-c-input
        class="form-input flex-1"
        label="Centro de custo"
        formControlName="CostCenter"
      >
      </app-c-input>
    </div>
    <div class="d-flex vw-100 column-gap-20 ptb-10">
      <app-c-input
        inputType="datetime-local"
        class="form-input flex-1"
        label="Data Vig. Inicial"
        formControlName="StartDate"
      >
      </app-c-input>
      <app-c-input
        inputType="datetime-local"
        class="form-input flex-1"
        label="Data Vig. Final"
        formControlName="FinishDate"
      >
      </app-c-input>
    </div>
    <div class="d-flex vw-100 column-gap-20 ptb-10">
      <app-c-select
        class="flex-1"
        width="100%"
        height="33px"
        label="Tipo beneficiário"
        alignItem="flex-start"
        formControlName="BeneficiaryType"
        borderRadius="5px"
        borderColor="#c4c4c4"
        [isStoreConfig]="true"
        [data]="parameters?.BeneficiaryType || []"
      ></app-c-select>

      <app-c-select
        class="flex-1"
        width="100%"
        height="33px"
        label="Tipo venda"
        alignItem="flex-start"
        formControlName="SaleType"
        borderRadius="5px"
        borderColor="#c4c4c4"
        [isStoreConfig]="true"
        [data]="parameters?.SaleType || []"
      ></app-c-select>
    </div>
    <div *ngIf="isPaymentBeneficiary" class="d-flex vw-100 column-gap-20 ptb-10 fade-in">
      <app-c-input
        class="form-input flex-1"
        label="Beneficiário"
        formControlName="BeneficiaryName"
      >
      </app-c-input>
      <app-c-input
        class="form-input flex-1"
        label="CPF/CNPJ beneficiário"
        formControlName="BeneficiaryDocument"
        inputMask="CPF_CNPJ"
        [dropSpecial]="false"
      >
      </app-c-input>
    </div>
    <div class="d-flex vw-100 column-gap-20 ptb-10 direction-column">
      <label class="label-text" for="modal-loja-obs">Observações</label>
      <textarea
        id="modal-loja-obs"
        formControlName="Obs"
        class="input-area flex-1"
        rows="5"
      ></textarea>
    </div>

    <div
      class="d-flex vw-100 column-gap-20 pt-20 justify-space-evenly modal-footer footer"
    >
      <button class="footer-back ui-btn ui-btn--secondary" mat-dialog-close>Voltar</button>
      <button
        class="footer-save ui-btn ui-btn--primary"
        [disabled]="form.invalid"
        (click)="saveStoreConfig()"
      >
        Salvar configuração
      </button>
    </div>
  </form>
</div>
